/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 8/12/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */
const SYNC_TYPE = {
  // 继承父级(仅限数据交互使用)
  Inherit: 0x10000000,

  // 是否同步
  None: 0,
  Sync: 1,

  // 同步范围
  Self: 2,
  Children: 4,

  // 同步类别
  ToUnit: 8,
  ToPub: 16,

  // 组同步策略
  WithDomainGroup: 32,
  WithOutDomainGroup: 64
};

// region 常用组合

// 常用组合第一组
SYNC_TYPE.SelfAndChildren = SYNC_TYPE.Self | SYNC_TYPE.Children; // 6
SYNC_TYPE.ToUnitOrPub = SYNC_TYPE.ToUnit | SYNC_TYPE.ToPub; // 24
SYNC_TYPE.WithAllGroup =
  SYNC_TYPE.WithDomainGroup | SYNC_TYPE.WithOutDomainGroup; // 96

// 常用组合第二组
SYNC_TYPE.SyncSelf = SYNC_TYPE.Sync | SYNC_TYPE.Self; // 3
SYNC_TYPE.SyncChildren = SYNC_TYPE.Sync | SYNC_TYPE.Children; // 5
SYNC_TYPE.SyncSelfAndChildren = SYNC_TYPE.Sync | SYNC_TYPE.SelfAndChildren; // 7
SYNC_TYPE.SyncWithDomainGroup = SYNC_TYPE.Sync | SYNC_TYPE.WithDomainGroup; // 33
SYNC_TYPE.SyncWithOutDomainGroup =
  SYNC_TYPE.Sync | SYNC_TYPE.WithOutDomainGroup; // 65
SYNC_TYPE.SyncWithAllGroup = SYNC_TYPE.Sync | SYNC_TYPE.WithAllGroup; // 97

// 常用组合第三组
SYNC_TYPE.SyncSelfToUnit = SYNC_TYPE.SyncSelf | SYNC_TYPE.ToUnit; // 11
SYNC_TYPE.SyncChildrenToUnit = SYNC_TYPE.SyncChildren | SYNC_TYPE.ToUnit; // 13
SYNC_TYPE.SyncSelfAndChildrenToUnit =
  SYNC_TYPE.SyncSelfAndChildren | SYNC_TYPE.ToUnit; // 15

SYNC_TYPE.SyncSelfToPub = SYNC_TYPE.SyncSelf | SYNC_TYPE.ToPub; // 19
SYNC_TYPE.SyncChildrenToPub = SYNC_TYPE.SyncChildren | SYNC_TYPE.ToPub; // 21
SYNC_TYPE.SyncSelfAndChildrenToPub =
  SYNC_TYPE.SyncSelfAndChildren | SYNC_TYPE.ToPub; // 23

SYNC_TYPE.SyncSelfToUnitOrPub = SYNC_TYPE.SyncSelf | SYNC_TYPE.ToUnitOrPub; // 27
SYNC_TYPE.SyncChildrenToUnitOrPub =
  SYNC_TYPE.SyncChildren | SYNC_TYPE.ToUnitOrPub; // 29
SYNC_TYPE.SyncSelfAndChildrenToUnitOrPub =
  SYNC_TYPE.SyncSelfAndChildren | SYNC_TYPE.ToUnitOrPub; // 31

// 常用组合第四组
SYNC_TYPE.SyncSelfToUnitWithDomainGroup =
  SYNC_TYPE.SyncSelfToUnit | SYNC_TYPE.WithDomainGroup; // 43
SYNC_TYPE.SyncChildrenToUnitWithDomainGroup =
  SYNC_TYPE.SyncChildrenToUnit | SYNC_TYPE.WithDomainGroup; // 45
SYNC_TYPE.SyncSelfAndChildrenToUnitWithDomainGroup =
  SYNC_TYPE.SyncSelfAndChildrenToUnit | SYNC_TYPE.WithDomainGroup; // 47
SYNC_TYPE.SyncSelfToPubWithDomainGroup =
  SYNC_TYPE.SyncSelfToPub | SYNC_TYPE.WithDomainGroup; // 51
SYNC_TYPE.SyncChildrenToPubWithDomainGroup =
  SYNC_TYPE.SyncChildrenToPub | SYNC_TYPE.WithDomainGroup; // 53
SYNC_TYPE.SyncSelfAndChildrenToPubWithDomainGroup =
  SYNC_TYPE.SyncSelfAndChildrenToPub | SYNC_TYPE.WithDomainGroup; // 55
SYNC_TYPE.SyncSelfToUnitOrPubWithDomainGroup =
  SYNC_TYPE.SyncSelfToUnitOrPub | SYNC_TYPE.WithDomainGroup; // 59
SYNC_TYPE.SyncChildrenToUnitOrPubWithDomainGroup =
  SYNC_TYPE.SyncChildrenToUnitOrPub | SYNC_TYPE.WithDomainGroup; // 61
SYNC_TYPE.SyncSelfAndChildrenToUnitOrPubWithDomainGroup =
  SYNC_TYPE.SyncSelfAndChildrenToUnitOrPub | SYNC_TYPE.WithDomainGroup; // 63

SYNC_TYPE.SyncSelfToUnitWithOutDomainGroup =
  SYNC_TYPE.SyncSelfToUnit | SYNC_TYPE.WithOutDomainGroup; // 75
SYNC_TYPE.SyncChildrenToUnitWithOutDomainGroup =
  SYNC_TYPE.SyncChildrenToUnit | SYNC_TYPE.WithOutDomainGroup; // 77
SYNC_TYPE.SyncSelfAndChildrenToUnitWithOutDomainGroup =
  SYNC_TYPE.SyncSelfAndChildrenToUnit | SYNC_TYPE.WithOutDomainGroup; // 79
SYNC_TYPE.SyncSelfToPubWithOutDomainGroup =
  SYNC_TYPE.SyncSelfToPub | SYNC_TYPE.WithOutDomainGroup; // 83
SYNC_TYPE.SyncChildrenToPubWithOutDomainGroup =
  SYNC_TYPE.SyncChildrenToPub | SYNC_TYPE.WithOutDomainGroup; // 85
SYNC_TYPE.SyncSelfAndChildrenToPubWithOutDomainGroup =
  SYNC_TYPE.SyncSelfAndChildrenToPub | SYNC_TYPE.WithOutDomainGroup; // 87
SYNC_TYPE.SyncSelfToUnitOrPubWithOutDomainGroup =
  SYNC_TYPE.SyncSelfToUnitOrPub | SYNC_TYPE.WithOutDomainGroup; // 91
SYNC_TYPE.SyncChildrenToUnitOrPubWithOutDomainGroup =
  SYNC_TYPE.SyncChildrenToUnitOrPub | SYNC_TYPE.WithOutDomainGroup; // 93
SYNC_TYPE.SyncSelfAndChildrenToUnitOrPubWithOutDomainGroup =
  SYNC_TYPE.SyncSelfAndChildrenToUnitOrPub | SYNC_TYPE.WithOutDomainGroup; // 95

SYNC_TYPE.SyncSelfToUnitWithAllGroup =
  SYNC_TYPE.SyncSelfToUnit | SYNC_TYPE.WithAllGroup; // 107
SYNC_TYPE.SyncChildrenToUnitWithAllGroup =
  SYNC_TYPE.SyncChildrenToUnit | SYNC_TYPE.WithAllGroup; // 109
SYNC_TYPE.SyncSelfAndChildrenToUnitWithAllGroup =
  SYNC_TYPE.SyncSelfAndChildrenToUnit | SYNC_TYPE.WithAllGroup; // 111
SYNC_TYPE.SyncSelfToPubWithAllGroup =
  SYNC_TYPE.SyncSelfToPub | SYNC_TYPE.WithAllGroup; // 115
SYNC_TYPE.SyncChildrenToPubWithAllGroup =
  SYNC_TYPE.SyncChildrenToPub | SYNC_TYPE.WithAllGroup; // 117
SYNC_TYPE.SyncSelfAndChildrenToPubWithAllGroup =
  SYNC_TYPE.SyncSelfAndChildrenToPub | SYNC_TYPE.WithAllGroup; // 119
SYNC_TYPE.SyncSelfToUnitOrPubWithAllGroup =
  SYNC_TYPE.SyncSelfToUnitOrPub | SYNC_TYPE.WithAllGroup; // 123
SYNC_TYPE.SyncChildrenToUnitOrPubWithAllGroup =
  SYNC_TYPE.SyncChildrenToUnitOrPub | SYNC_TYPE.WithAllGroup; // 125
SYNC_TYPE.SyncSelfAndChildrenToUnitOrPubWithAllGroup =
  SYNC_TYPE.SyncSelfAndChildrenToUnitOrPub | SYNC_TYPE.WithAllGroup; // 127

// endregion

export default SYNC_TYPE;
